import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import RootLanding from "@/pages/RootLanding";
import ThankYou from "@/pages/ThankYou";
import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import ApplicantStatus from "@/pages/ApplicantStatus";
import TalentCard from "@/pages/TalentCard";
import RosterPage from "@/pages/RosterPage";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import PendingApproval from "@/pages/PendingApproval";
import ContractorDashboard from "@/pages/ContractorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<RootLanding />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/join" element={<Landing />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/status" element={<ApplicantStatus />} />
            <Route path="/talent/:token" element={<TalentCard />} />
            <Route path="/roster/:token" element={<RosterPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/pending" element={<PendingApproval />} />
            <Route path="/portal" element={<ProtectedRoute role="creative"><ContractorDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
